import {AbstractApiModel} from "./abstract.api.model";
import {Exclude, Expose} from "class-transformer";

@Exclude()
export class StatusApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public name: string;
  @Expose() public const: string;
}
